import React, { useRef, useEffect } from "react";
import JsBarcode from "jsbarcode";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export const Barcode = ({ value, className }) => {
	const svgRef = useRef(null);

	useEffect(() => {
		if (svgRef.current && value != null) {
			JsBarcode(svgRef.current, value, {
				format: "CODE128",
				width: 2,
				height: 60,
				displayValue: true,
			});
		}
	}, [value]);

	return <svg ref={svgRef} className={className}></svg>;
};

export const CodeDialog = ({ open, onClose, value, title = "" }) => {
	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" disableEscapeKeyDown={false}>
			<DialogTitle style={{ display: "flex", alignItems: "center", position: "relative" }}>
				<span style={{ fontWeight: 600, textAlign: "left" }}>{title}</span>
				<IconButton
					size="small"
					onClick={onClose}
					style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)" }}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent
				style={{ padding: 24, display: "flex", justifyContent: "center", alignItems: "center" }}
			>
				<Barcode value={value} />
			</DialogContent>
		</Dialog>
	);
};

export default CodeDialog;
